// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1gkWE","dragIcon":"SortableItem_dragIcon__oJCrl","disabled":"SortableItem_disabled__10jn-"};